<div class="ko-lap">
  <ion-card>
    <ion-card-header>
      <ion-card-title>KRÉTA önteszt</ion-card-title>
      <ion-card-subtitle>
        Funkciónként megmutatja, működik-e a KRÉTA-kapcsolat. A KRÉTÁ-ban semmit nem ír: csak belép, és olvasó
        hívásokkal ellenőriz. Az adatkörönkénti átviteli számokat a <a routerLink="/admin/kreta-atvitel">KRÉTA-átvitel állapota</a> lap mutatja.
      </ion-card-subtitle>
    </ion-card-header>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Ütemezett feladatok</ion-card-title>
      <ion-card-subtitle>Az automatikus KRÉTA-szinkron utolsó futásai, feladatonként.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ko-fej">
        <ion-button size="small" fill="outline" (click)="feladatBetolt()" [disabled]="feladatToltodik">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>
      <div *ngIf="feladatToltodik && !feladatok.length"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
      <ion-note color="danger" *ngIf="feladatHiba">{{ feladatHiba }}</ion-note>
      <ion-note color="medium" *ngIf="!feladatToltodik && !feladatHiba && !feladatok.length">Ebben az intézményben még nem futott ütemezett KRÉTA-feladat.</ion-note>
      <div class="ko-gorgeto" *ngIf="feladatok.length">
        <table class="ko-tabla">
          <thead>
            <tr><th>Feladat</th><th>Állapot</th><th>Utolsó futás</th><th>Utoljára sikeres</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of feladatok" [ngClass]="'ko-' + szin(f.allapot)">
              <td><b>{{ f.cim }}</b><div class="halvany">{{ f.irany }}</div></td>
              <td class="ko-uzenet">
                <ion-badge [color]="szin(f.allapot)">{{ allapotNev[f.allapot] || f.allapot }}</ion-badge>
                <div>{{ f.uzenet }}</div>
                <div class="ko-hibas" *ngIf="f.hibas_db">{{ ido(f.hibas_ota) }} óta {{ f.hibas_db }} futás egymás után hibás.</div>
                <div class="halvany" *ngFor="let r of f.reszletek">{{ r.cim }}: {{ ido(r.ido) }}</div>
              </td>
              <td class="ko-ido">{{ ido(f.utolso_futas) }}</td>
              <td class="ko-ido">{{ ido(f.utolso_sikeres) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Önteszt funkciónként</ion-card-title>
      <ion-card-subtitle>
        A tanári fiókkal a naplózás, a helyettesítés, a jegy, a mulasztás, az igazolás, a feljegyzés és az órarend
        végpontjait nézi; az adminisztrációs fiókkal a csoporttagságot és a tanulói adatokat. A helyettesítések és az
        új tanulók sorsát az adatbázisból ellenőrzi.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ko-fej">
        <ion-select label="Tanári fiók" label-placement="stacked" interface="popover" [(ngModel)]="tanarFiok" [disabled]="onteszt?.fut">
          <ion-select-option value="">az első aktív fiók</ion-select-option>
          <ion-select-option *ngFor="let f of fiokok" [value]="f.allomany">
            {{ f.tanar_nev || f.allomany }} ({{ f.kreta_user }}){{ f.aktiv ? '' : ' – inaktív' }}
          </ion-select-option>
        </ion-select>
        <ion-select label="Adminisztrációs fiók" label-placement="stacked" interface="popover" [(ngModel)]="adminFiok" [disabled]="onteszt?.fut">
          <ion-select-option value="">az ütemezőben kijelölt</ion-select-option>
          <ion-select-option *ngFor="let f of fiokok" [value]="f.allomany">
            {{ f.tanar_nev || f.allomany }} ({{ f.kreta_user }})
          </ion-select-option>
        </ion-select>
        <ion-button size="small" (click)="ontesztIndit(true)" [disabled]="inditas || onteszt?.fut">
          <ion-icon slot="start" name="pulse-outline"></ion-icon>Teljes önteszt
        </ion-button>
        <ion-button size="small" fill="outline" (click)="ontesztIndit(false)" [disabled]="inditas || onteszt?.fut"
                    title="Csak a helyettesítések és az új tanulók ellenőrzése, KRÉTA-belépés nélkül">
          Csak adatbázis
        </ion-button>
      </div>
      <ion-note color="medium" *ngIf="!fiokok.length">Nincs jelszóval felvett KRÉTA-fiók – a KRÉTA-oldali ellenőrzéshez előbb vegyél fel egyet (KRÉTA naplózás).</ion-note>

      <div *ngIf="onteszt?.fut" class="ko-fut"><ion-spinner name="dots"></ion-spinner> Fut: {{ onteszt.lepes || '…' }}</div>

      <ng-container *ngIf="onteszt?.eredmeny as e">
        <div class="ko-eredmeny-fej">
          <ion-badge [color]="szin(e.osszegzes)">{{ allapotNev[e.osszegzes] || e.osszegzes }}</ion-badge>
          <span class="halvany">
            {{ ido(e.vege) }}<span *ngIf="e.kreta_user"> · tanári fiók: {{ e.tanar_nev || e.allomany }} ({{ e.kreta_user }})</span><span *ngIf="e.admin_fiok"> · adminisztrációs fiók: {{ e.admin_fiok }}</span><span *ngIf="e.kreta_host"> · {{ e.kreta_host }}</span><span *ngIf="e.kreta === false"> · csak adatbázis</span>
          </span>
        </div>

        <section class="ko-funkcio" *ngFor="let f of csoportok(e)">
          <h3><ion-badge [color]="szin(f.allapot)">{{ allapotNev[f.allapot] || f.allapot }}</ion-badge> {{ f.cim }}</h3>
          <div class="ko-ellenorzes" *ngFor="let c of f.sorok" [ngClass]="'ko-' + szin(c.allapot)">
            <div class="ko-ell-cim"><b>{{ c.cim }}</b> <span class="halvany">· {{ allapotNev[c.allapot] || c.allapot }}</span></div>
            <div>{{ c.uzenet }}</div>
            <div class="halvany" *ngIf="c.hianyzo_mezok?.length">Hiányzó mező(k): {{ c.hianyzo_mezok.join(', ') }}</div>
            <ul class="ko-peldak" *ngIf="c.peldak?.length"><li *ngFor="let p of c.peldak">{{ p }}</li></ul>
          </div>
        </section>
        <ion-note color="medium" class="ko-megj" *ngIf="e.kreta !== false && hianyzoFunkciok(e).length">
          Nem ellenőrizve (a KRÉTA-belépés nem sikerült, vagy nincs hozzá fiók): {{ hianyzoFunkciok(e).join(', ') }}.
        </ion-note>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
